import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";

export class TitleContainer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT / 2 - 430 * GameVars.scaleY;

        this.scaleY = GameVars.scaleY;

        const titleBar = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_2", "title_bar");
        this.add(titleBar);

        const templokTitle = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_3", "templok_title");
        this.add(templokTitle);
    }
}
